import { Component, OnInit } from "@angular/core";
import { MatDialog } from "@angular/material";

import { AuthenticationService, AuthenticationState } from "./common/authentication/authentication.service";
import { SessionIdleService, IdleState } from "./common/session-idle/session-idle.service";
import { ConfirmationDialogComponent } from "./administrative/confirmation-dialog/confirmation-dialog.component";
import { TranslateService } from "./common/translate";

@Component({
	selector: "sdp-root",
	templateUrl: "./app.component.html"
})
export class AppComponent implements OnInit {

	private currentAuthState: AuthenticationState | undefined;

	constructor(
		private authService: AuthenticationService,
		private sessionIdleService: SessionIdleService,
		private translateService: TranslateService,
		public dialog: MatDialog
	) { }

	public ngOnInit(): void {
		// Setup subscriptions to pay attention to the idle status of the session
		this.sessionIdleService.expired.subscribe((idleState: IdleState.State) => {
			if (idleState === "WARNING" && this.authService.isLoggedIn()) {
				// if you are logged in and the timer warns, show modal
				this.showIdleDialog();
			} else if (idleState === "EXPIRED" && this.authService.isLoggedIn()) {
				// if you are logged in and the timer expires, log out user
				this.dialog.closeAll();
				this.sessionIdleService.stopWatching();
				this.authService.logout({
					idle: true,
					userDisabled: false
				});
			}
		});
		if (this.authService.isLoggedIn()) {
			this.sessionIdleService.startWatching();
		}

		// Setup subscriptions to pay attention to the auth status of the session
		this.authService.authState.subscribe((authState: AuthenticationState) => {
			this.currentAuthState = authState;
		});
	}

	public isUserRefreshing() {
		if (!!this.currentAuthState) {
			return this.currentAuthState.state === "REFRESHING";
		} else {
			return false;
		}
	}

	private showIdleDialog() {
		const dialogRef = this.dialog.open(ConfirmationDialogComponent, {});
		dialogRef.componentInstance.message = this.translateService.translate("sdp.session.idle.message");
		dialogRef.componentInstance.title = "sdp.session.idle.title";
		dialogRef.componentInstance.buttonAction = "sdp.session.idle.button";
	}
}
